import React from 'react';
import { ClientEvent, ClientEventData } from '../helpers/GoFormzAnalytics-types';
import { ForPersonalIcon_Light, ForWorkIcon_Light, getIcon, MyClientsIcon_Light, MyselfIcon_Light, MyTeamIcon_Light } from './icons';

export type Survey = {
  [page: number]: SurveyQuestion;
};

export type SurveyQuestion = {
  title?: string;
  subTitle?: string;
  /** The delay to wait before moving onto the next question */
  delay: number;
  className?: string;
  trackEvent?: string;
  trackAs?: string;
  trackGoFormzEvent?: ClientEvent;
  answers?: SurveyAnswer[];
  last?: boolean;
  skippable?: boolean;
  multiSelect?: boolean;
};

export type SurveyAnswer = {
  answer: string;
  segmentAnswer?: string;
  icon?: JSX.Element | string;
  description?: string;
  key: ClientEventData;
};

export const survey: Survey = {
  1: {
    className: 'first',
    title: 'How will you use GoFormz?',
    trackEvent: 'GoFormz Intent',
    trackAs: 'Intent',
    trackGoFormzEvent: ClientEvent.OnboardingGoFormzIntent,
    delay: 500,
    answers: [
      {
        answer: 'For work',
        segmentAnswer: 'Business use',
        description: 'Create digital forms and automated processes for my team.',
        icon: <ForWorkIcon_Light />,
        key: ClientEventData.OnboardingGoFormzIntent_Business
      },
      {
        answer: 'For personal use',
        segmentAnswer: 'Personal use',
        description: 'I need to fill out and send forms.',
        icon: <ForPersonalIcon_Light />,
        key: ClientEventData.OnboardingGoFormzIntent_Personal
      }
    ]
  },
  2: {
    className: 'second',
    title: 'Who is going to fill out your forms?',
    trackEvent: `Who's Filling Out Forms`,
    trackAs: 'Answer',
    trackGoFormzEvent: ClientEvent.OnboardingWhosFillingForms,
    delay: 500,
    answers: [
      { answer: 'My team', icon: <MyTeamIcon_Light />, key: ClientEventData.OnboardingWhosFillingForms_Team },
      { answer: 'My clients', segmentAnswer: 'My customers', icon: <MyClientsIcon_Light />, key: ClientEventData.OnboardingWhosFillingForms_Customers },
      { answer: 'Myself', icon: <MyselfIcon_Light />, key: ClientEventData.OnboardingWhosFillingForms_Myself }
    ]
  },
  3: {
    className: 'third',
    title: 'Which of these tools do you use, or plan to use?',
    subTitle: 'Select all that apply',
    trackEvent: `What Tools You Use`,
    trackAs: 'Answer',
    trackGoFormzEvent: ClientEvent.OnboardingWhatToolsYouUse,
    delay: 500,
    skippable: true,
    multiSelect: true,
    answers: [
      { answer: 'Google', icon: getIcon('g suite'), key: ClientEventData.OnboardingGoFormzApps_Google },
      { answer: 'OneDrive', icon: getIcon('onedrive'), key: ClientEventData.OnboardingGoFormzApps_OneDrive },
      { answer: 'Box', icon: getIcon('box'), key: ClientEventData.OnboardingGoFormzApps_Box },
      { answer: 'Dropbox', icon: getIcon('dropbox'), key: ClientEventData.OnboardingGoFormzApps_Dropbox },
      { answer: 'Procore', icon: getIcon('procore'), key: ClientEventData.OnboardingGoFormzApps_Procore },
      { answer: 'Smartsheet', icon: getIcon('smartsheet'), key: ClientEventData.OnboardingGoFormzApps_Smartsheet },
      { answer: 'Salesforce', icon: getIcon('salesforce'), key: ClientEventData.OnboardingGoFormzApps_Salesforce },
      { answer: 'SQL Server', icon: getIcon('sql server (beta)'), key: ClientEventData.OnboardingGoFormzApps_SqlServer },
      { answer: 'Egnyte', icon: getIcon('egnyte'), key: ClientEventData.OnboardingGoFormzApps_Egnyte },
      { answer: 'Acumatica', icon: getIcon('acumatica'), key: ClientEventData.OnboardingGoFormzApps_Acumatica }
    ]
  },
  4: {
    className: 'fourth',
    delay: 100,
    last: true
  }
};
